import { StyleSheet } from "@react-pdf/renderer"

export const headerStyles=()=>{

    const header = StyleSheet.create({
        container: {
            height:90,
            width: '100%',
            alignSelf: 'center',
            flexDirection: 'row',
        },
        image: {
            width: '30%',
            height: '100%',
            borderRightColor: 'black'
        },
        dataHeaderContainer: {
            width: '70%',
            height: '100%',
            flexDirection: 'row',
            justifyContent:'space-between'
        },
        dataIssuingCompanyContainer: {
            width: '50%',
            alignItems:'center',
            flexDirection: 'column',
            paddingHorizontal: 10,
            gap: .5,
        },
        dataIssuingCompanyContainer2: {
            width: '40%',
            height:'90%',
            flexDirection: 'column',
            paddingHorizontal: 10,
        },
        dataIssuingCompanyContainer3: {
            width: '100%',
        },
        dataInvoiceGeneralSubcontainer: {
            flexDirection: 'row',
            justifyContent: 'space-between'
        },
        textHeaderStyles: {
            fontSize: 7,
            paddingVertical: 3,
            fontWeight:400
        },
        textHeaderStylesBold: {
            fontSize: 10,
            paddingVertical: 3,
            fontWeight: 700,
        },
        textHeaderStylesBold2: {
            width:'40%',
            fontSize: 7,
            paddingVertical: 3,
            fontWeight: 700,
            justifyContent:'flex-end',
            textAlign:'right',
            borderRightWidth:1,
            paddingRight:2
        }
    })

    return {
        header
    }
}